import script from "./cc.vue?vue&type=script&lang=ts&setup=true"
export * from "./cc.vue?vue&type=script&lang=ts&setup=true"

import "./cc.vue?vue&type=style&index=0&id=7512fc62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7512fc62"]])

export default __exports__